exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3nl-xj3qkB6EeuDKABpzmp{font-size:13px;font-weight:500px;line-height:14px}._1Cvm6JnP0_U6OEBXe0Zy-V{padding-bottom:20px}._1Js5iBMkmJOL_OE5sAmuJg{font-size:13px;color:#616161;line-height:20px}._3gWsBJx2fD5Qvu4NSD-psr{display:flex;justify-content:space-between;padding-bottom:20px}._14QUThf0_PkNDerbdGm5JA{height:90px;width:185px;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"viewMessagesLink": "_3nl-xj3qkB6EeuDKABpzmp",
	"row": "_1Cvm6JnP0_U6OEBXe0Zy-V",
	"createdAt": "_1Js5iBMkmJOL_OE5sAmuJg",
	"empty": "_3gWsBJx2fD5Qvu4NSD-psr",
	"explainer": "_14QUThf0_PkNDerbdGm5JA"
};